// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1971) return "static/chunks/02d30405-5eeadedc11285f81.js";
	if (chunkId === 8594) return "static/chunks/8594-5649d56fa59908ea.js";
	if (chunkId === 9375) return "static/chunks/9375-12fa6b5f2abdf35f.js";
	if (chunkId === 9623) return "static/chunks/9623-6b80ce284a63cf78.js";
	if (chunkId === 7600) return "static/chunks/7600-671b22e145fca6d3.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"54":"1b34c61698aab779","308":"45b689e016a9692c","1117":"e2c68699c3b6135d","2140":"03ee40c0582758b7","2592":"e1251a3149f1a825","3156":"73e657ddec4a6d95","3688":"1b9c184f9acef629","4686":"115275b932ae91d1","9074":"3d36a92b41c5b87c","9724":"96943211c83b5fbc"}[chunkId] + ".js";
};